import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ImagePlus, Loader2 } from "lucide-react";
import { API, authHeaders, formatApiError } from "./AdminPage";
import { resolveMedia } from "../../siteContext";
import { useAdminT } from "./adminI18n";

const inputCls =
  "w-full bg-luxury-black border border-luxury-border text-luxury-bone px-4 py-3 focus:outline-none focus:border-luxury-gold";

export const ImageField = ({ label, value, onChange, testid }) => {
  const { t } = useAdminT();
  const [uploading, setUploading] = useState(false);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const data = new FormData();
      data.append("file", file);
      const res = await axios.post(`${API}/admin/images/upload`, data, { headers: authHeaders() });
      onChange(res.data.url);
      toast.success(t("تم رفع الصورة"));
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setUploading(false);
    }
  };

  return (
    <div data-testid={testid}>
      <label className="block text-sm text-luxury-gray mb-2">{label}</label>
      <div className="flex items-center gap-4 flex-wrap">
        {value ? (
          <img src={resolveMedia(value)} alt="" className="h-16 w-16 object-cover rounded-lg border border-luxury-border" />
        ) : null}
        <label
          data-testid={testid ? `${testid}-upload` : undefined}
          className="flex items-center gap-2 border border-luxury-border text-luxury-gold px-4 py-2.5 rounded-full text-sm cursor-pointer hover:border-luxury-gold transition-colors"
        >
          {uploading ? <Loader2 className="w-4 h-4 animate-spin" /> : <ImagePlus className="w-4 h-4" strokeWidth={1.5} />}
          {uploading ? t("جارٍ الرفع...") : t("رفع من الجهاز")}
          <input type="file" accept="image/*" onChange={upload} className="hidden" />
        </label>
        <input
          dir="ltr"
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          className={`${inputCls} flex-1 min-w-[200px]`}
          placeholder={t("أو الصقي رابط صورة https://...")}
        />
      </div>
    </div>
  );
};
